import Person from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState, franchiseSelector } from '../../common/store/store';

const FooterGrid = (props: { children: React.ReactNode; }) => {
    return <Box className='dark' sx={{ flex: 1, p: 2, pb: { sx: 2, sm: 10, md: 10, lg: 10 }, color: 'white', borderTop: 'solid 3px white' }}>{props.children}</Box>;
};

const callback = (...args: any) => {
    console.log('callback', args);
};

export const Footer = () => {



    const sendCliqueSurTelephone = () => {

        (window as any)['gtag']('event', 'conversion_event_contact', {
            'event_callback': callback,
            'event_timeout': 2000
        });

    };
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, state.device.currFranchise));

    const getAdresses = (): React.ReactNode => {
        switch (franchise?.id) {
            case 2:
                return <>
                    <Typography variant='h5' className='blanc'>Points de service</Typography>
                    <Typography>
                        <strong>Québec</strong><br />
                        330 av Saint-Michel<br />
                        Québec, Qc<br />
                        G1C 1G5
                    </Typography>
                    <Typography>
                        <strong>Lévis</strong><br />
                        110 Rue des Cèdres<br />
                        Saint-Lambert, Qc<br />
                        G0S 2W0
                    </Typography>
                </>;
            case 3:
                return <>
                    <Typography variant='h5' className='blanc'>Points de service</Typography>
                    <Typography>
                        <strong>Drummondville</strong><br />
                        840 Rue Bergeron,<br />
                        Drummondville, QC<br />
                        J2C 0C1
                    </Typography>
                </>;
            default:
                return <>
                    <Typography variant='h5' className='blanc'>Points de service</Typography>
                    <Typography>
                        <strong>Montréal (Ouest)</strong><br />
                        111 rue Huot, Notre-Dame-de-l'Île-Perrot<br />
                        Québec, Qc<br />
                        J7J 7M4
                    </Typography>
                    <Typography>
                        <strong>Cowansville</strong><br />
                        420 Rue Mélodie<br />
                        Cowansville, Qc<br />
                        J2K 3G6
                    </Typography>
                </>;
        }
    };

    return <Container>
        <div style={{ height: '10px' }}></div>
        <Container>
            <Typography sx={{ fontSize: '12px', color: '#b4b4b4' }}><sup>*</sup>La garantie à vie inclut une garantie de 25 ans sur les matériaux galvanisés et de 15 ans sur les travaux standard..</Typography>
        </Container>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
            <FooterGrid>
                <Typography component='p'>
                    <strong>{franchise?.name ?? 'Pieux Protech'}</strong><br />
                    <em>Protégez votre investissement !</em>
                </Typography>
                <Typography variant='h5' className='blanc'>Points de service</Typography>
                <div dangerouslySetInnerHTML={{ __html: franchise?.pointsDeService ?? "" }} />
            </FooterGrid>
            <FooterGrid>

                <Typography component='p'>
                    <strong>Contact</strong>
                </Typography>
                {franchise?.contactName ? <Typography component='p'>
                    <Person />{franchise.contactName}
                </Typography> : null}
                <Typography component='p'>
                    <LocalPhoneIcon /> Tél.: {franchise?.tel ? <a onClick={sendCliqueSurTelephone} href={'tel:' + franchise.tel}>{franchise.tel}</a> : <a href="tel:+15144975636">(514) 497-5636</a>}
                </Typography>
                {franchise?.email ? <Typography component='p'>
                    <EmailIcon /> Courriel: <a href={`mailto:${franchise.email}`}>{franchise.email}</a>
                </Typography> : null}
            </FooterGrid>
            <FooterGrid>

                <Typography component='p'>
                    <strong>Nous trouver sur Internet</strong>
                </Typography>
                <Typography component='p'>
                    <PublicIcon /> <a href="https://lespieuxprotech.com">lespieuxprotech.com</a>
                </Typography>
                {franchise?.facebookUrl ? <Typography component='p'>
                    <FacebookIcon /> <a href={franchise.facebookUrl}>Page Facebook</a>
                </Typography> : null}
                {franchise?.googleMapUrl ? <Typography component='p'>
                    <LocationOnIcon /> <a href={franchise.googleMapUrl}>Google map</a>
                </Typography> : null}
            </FooterGrid>
        </Box>
    </Container >;
};
